module.exports = __webpack_public_path__ + "/public/font/edd813898ad3e3864510790ecbf2fe01.eot";